import { useParamsSearch } from '@anytag/shared-hooks';
import { ProposalJobDescriptionBreakDownMode } from '@anytag/graphql';
import { PackageProposalSearchSchemaType, ProposeInfluencersTableMode } from '@anytag/shared-organisms';

export const usePackageContentInfluencersSearch = () => {
  const paramsSearch = useParamsSearch<PackageProposalSearchSchemaType>();

  const { filter } = paramsSearch;

  return {
    ...paramsSearch,
    jdMode: filter.jdMode as ProposalJobDescriptionBreakDownMode,
    isViewMode: filter.tableViewMode === ProposeInfluencersTableMode.VIEW,
    isEditMode: filter.tableViewMode === ProposeInfluencersTableMode.EDIT
  };
};
